import { render, staticRenderFns } from "./PointProgramsSystemMessage.vue?vue&type=template&id=94b7137a&scoped=true&"
import script from "./PointProgramsSystemMessage.vue?vue&type=script&lang=js&"
export * from "./PointProgramsSystemMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b7137a",
  null
  
)

export default component.exports